import angular from 'angular';
import template from './mobile-actions-mini.html';
class Controller {
}
const component = {
    template,
    bindings: {
        stream: '<',
        disabled: '<',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callFrames.mobileActionsMini', [])
    .component('mobileActionsMini', component).name;
